import React from 'react'
import styled from 'styled-components'
import MenPage from '../components/menpage/MenPage'
import HomePageMHeader from '../components/homepagemheader/HomePageMHeader'
import { Seo } from '../components/seo'
const Screen = styled.div
`
max-width: 1920px !important;
`

const men = () => {
  return (
    <Screen className='container mx-auto w-full  flex-grow'>
       <Seo />
     <HomePageMHeader />
    <MenPage />
    </Screen>

  )
}

export default men